<template>
  <div>
    <panel-header>
      <back-link slot="arrow">
        <panel-header-back-arrow />
      </back-link>
      <span slot="text">Источники</span>
    </panel-header>

    <div class="row">
      <div class="col">
        <div class="white-wrapper">
          <p v-if="! isMobile">Источники информации:</p>
          <ul class="list-unstyled m-0">
          <li>
            Информация о лунном дне &mdash; <a href="https://my-calend.ru/moon" target="_blank" ref="nofollow">my-calend.ru</a>.
          </li>
          <li>Гороскоп &mdash; <a href="https://1001goroskop.ru" target="_blank" ref="nofollow">1001goroskop.ru</a>.</li>
        </ul>
        </div>
        <div class="col-12 text-center mt-3" v-if="! isMobile">
          <back-link />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import PanelHeader from "@/components/PanelHeader/PanelHeader";
import BackLink from "@/components/_Utlis/BackLink";
import client from "@/services/client";
import PanelHeaderBackArrow from "@/components/PanelHeader/PanelHeaderBackArrow";

export default {
  name: "Origin",
  components: {
    PanelHeaderBackArrow,
    BackLink,
    PanelHeader,
  },
  computed: {
    isMobile() {
      return client.isMobile();
    },
  }
}
</script>

<style lang="scss" scoped>

</style>